import { useCallback } from 'react';
import { setRedirectOnFeatureSelection } from '@redux/map/map-reducer';
import { useDispatch } from 'react-redux';
import {
    setCutMode,
    setDrawerToDefault,
    setDrawnFeatures,
    setIsDrawMode,
} from '@redux/draw/draw-reducer';
// eslint-disable-next-line import/no-restricted-paths
import { drawRef } from '@features/map/draw/DrawControl';

export const useLayersInteractivity = () => {
    const dispatch = useDispatch();

    //----------------------------------

    const toggleRedirectOnFeatureSelection = useCallback((enable = false) => {
        dispatch(setRedirectOnFeatureSelection(enable));
    }, []);

    //----------------------------------

    const saveDrawnFeatures = useCallback((features: GeoJSON.Feature<GeoJSON.Geometry>[]) => {
        dispatch(setDrawnFeatures(features));
    }, []);

    const cleanDrawnFeatures = useCallback(() => {
        dispatch(setDrawnFeatures());
    }, []);

    const setDrawing = useCallback((isDrawing: boolean) => {
        dispatch(setIsDrawMode(isDrawing));
        if (!isDrawing) {
            cleanDrawnFeatures();
        }
    }, []);

    const resetCutMode = useCallback(() => {
        dispatch(setCutMode(false));
    }, []);

    const recoverSettingsAfterDrawing = useCallback(() => {
        dispatch(setDrawerToDefault());
        setDrawing(false);
        drawRef?.deleteAll();
    }, [setDrawing]);

    return {
        toggleRedirectOnFeatureSelection,
        setDrawing,
        saveDrawnFeatures,
        cleanDrawnFeatures,
        resetCutMode,
        recoverSettingsAfterDrawing,
    };
};
